import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/shared/data/data.service';
import { apiResultFormat, productList } from 'src/shared/models/pages.model';

@Component({
    selector: 'app-new-products',
    templateUrl: './new-products.component.html',
    styleUrls: ['./new-products.component.scss']
})
export class NewProductsComponent implements OnInit {
    public productItems: productList[] = [];
    public selectedProduct: productList | null = null;
    public isMobile: boolean = false;
    newArrivalItems: any[] = [];
    base_url:any="https://thesmilesstore.in/"
    Categories: any[];
    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        public data: DataService,
        private fb: FormBuilder,
    ) {}


    ngOnInit(): void {
        // this.loadInitialData();
        this.isMobile = window.innerWidth <= 767;
        window.addEventListener('resize', () => {
          this.isMobile = window.innerWidth <= 767;
        });

        // this.getNewArrivals()
        this.getProjectCategories();
    }




    getProjectCategories(): void {

        this.http.post<any>(
            this.data.base_url+'category_data/',
            {}
        ).subscribe({

            next: (response) => {

                if (response.status == 1) {

                    const categories = response.data.map((item: any) => {
                        return {
                            id: item.category_id,
                            name: item.category_name,
                            active: false
                        };
                    });

                    this.Categories = [
                        { id: '', name: 'All Projects', active: true },
                        ...categories
                    ];

                    // ✅ FIND "Popular" CATEGORY ID FROM API
                    const popularCategory = categories.find(
                        (cat: any) =>
                            cat.name.toLowerCase().trim() === 'new arrivals'
                    );
                  
                    if (popularCategory) {
                        
                        // 👇 CALL getProjects WITH ID
                        this.getNewArrivals(popularCategory.id);
                    }
                }

            },

            error: (error) => {
                console.log(error);
            }

        });

    }


getNewArrivals(category?: string): void {
     const payload = category && category !== '' && category !== 'all'
            ? { category: category }
            : {};

        console.log('📤 Sending payload to backend:', payload);

    this.http.post<any>(
        this.data.base_url+'/supplychain/product_data/',
       payload

    ).subscribe({

        next: (response) => {

            if (response.status == 1 && response.data) {

                this.newArrivalItems = response.data.map((project: any) => {

                    return {

                        id: project.id,

                        product_name: project.product_name,

                        product_price: project.product_cost,

                        description: project.product_description,

                        product_image:
                            project.product_image

                    };

                });

            } else {

                this.newArrivalItems = [];

            }

        },

        error: (error) => {

            console.log(error);

            this.newArrivalItems = [];

        }

    });

}





}
